<template>
  <div class="patient-fields">
    <div class="patient-name-container">
      <label for="name-input">{{ nameLabel }}</label>
      <md-field :class="{'md-invalid': false}" :md-counter="true">
        <md-input
          id="name-input"
          :aria-label="nameLabel"
          data-testid="name-input"
          :value="state.name"
          :maxlength="30"
          :disabled="readonly"
          @input="name => selectName(name)"
        />
      </md-field>
    </div>
    <voice-selector
      :avatar-key="avatarKey"
      :voice-key="voiceKey"
      :disabled-voice-keys="disabledVoiceKeys"
      :voices="voices"
      :readonly="readonly"
      @update="selectVoice"
    />
    <outfit-selector
      :user="user"
      :avatar="avatars.find(a => a.key === avatarKey)"
      :outfit="outfit"
      :show-on-at-start="showOnAtStart"
      :readonly="readonly"
      @update="selectOutfit"
    />
  </div>
</template>

<script>
import VoiceSelector from '../../common/VoiceSelector.vue'
import OutfitSelector from '../../common/OutfitSelector.vue';

export default {
  name: 'patient-fields',
  components: {
    VoiceSelector,
    OutfitSelector,
  },
  props: {
    avatars: {
      type: Array,
      default: () => []
    },
    voices: {
      type: Array,
      default: () => []
    },
    disabledVoiceKeys: {
      type: Array,
      default: () => []
    },
    name: {
      type: String,
      default: null
    },
    nameLabel: {
      type: String,
      default: 'Patient Name'
    },
    avatarKey: {
      type: String,
      default: null
    },
    voiceKey: {
      type: String,
      default: null
    },
    user: {
      type: Object,
      default: () => {}
    },
    outfit: {
      type: Object,
      default: () => {}
    },
    showOnAtStart: {
      type: Boolean,
      default: true
    },
    readonly: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      state: {
        name: this.name
      }
    }
  },
  watch: {
    name(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.state.name = newValue;
      }
    }
  },
  methods: {
    selectName(value) {
      this.state.name = value;
      this.$emit('selectName', value);
    },
    selectVoice(value) {
      this.$emit('selectVoice', value)
    },
    selectOutfit(value) {
      this.$emit('selectOutfit', value)
    }
  }
}
</script>

<style scoped>
.patient-fields {
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-right: 10px;
}

.patient-name-container {
  margin-bottom: 10px;
}

.voice-selector {
  margin-bottom: 10px;
}
</style>